import {
  FORM_GREY,
  HISTOWIZ_PRIMARY_COLOR,
  TRANSPARENT_BLACK_10,
} from 'utilities/colors';
import { makeStyles } from 'tss-react/mui';

export const useTransactionTypeSelectorStyles = makeStyles()(() => ({
  tabLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabLabel: {
    lineHeight: '1.5rem',
    fontSize: '0.75rem',
  },
  infoIcon: {
    fontSize: '1.125rem',
    marginRight: '0.5rem',
  },
  tabsWrapper: {
    padding: '0.25rem',
    border: `1px solid ${TRANSPARENT_BLACK_10}`,
    borderRadius: '5px',
  },
  tab: {
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    minWidth: 'min-content',
    padding: '0.25rem 1rem',
    height: '2.3rem',
    minHeight: '2.3rem',
    marginRight: '0.5rem',
    fontWeight: 500,
    opacity: 1,
    border: '1px solid transparent',
    '&:hover': {
      color: HISTOWIZ_PRIMARY_COLOR,
      border: `1px solid ${HISTOWIZ_PRIMARY_COLOR}`,
      borderRadius: '4px',
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  tabs: {
    height: '2.3rem',
    minHeight: '2.3rem',
  },
  indicator: {
    display: 'none',
  },
  selectedTab: {
    backgroundColor: HISTOWIZ_PRIMARY_COLOR,
    color: 'white !important',
    borderRadius: '4px',
  },
}));

export const useGroupViewStyles = makeStyles()(() => ({
  infoIcon: {
    color: FORM_GREY,
    marginRight: '0.5rem',
  },
  groupHeader: {
    paddingLeft: '1rem',
    display: 'flex',
    alignItems: 'center',
    // height: '42px',
    width: 'max-content',
  },
  accordion: {
    marginBlock: '0 !important',
    boxShadow: 'none',

    '& .Mui-expanded': {
      minHeight: '42px !important',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      '& .Mui-expanded': {
        margin: 0,
      },
    },
    '&::before': {
      display: 'none',
    },
  },
  accordionSummary: {
    flexDirection: 'row-reverse',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_10}`,
    marginLeft: '0 !important',
    height: '42px',
    minHeight: '42px !important',
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
  },
  accordionDetails: {
    padding: 0,
  },
}));
